import axios from "axios";

export const getSection6 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/landing-page-s6-capability?populate[Capabilities][populate]=*&populate=Image`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
